import type { JobLineStatus, JobStatus } from '../api/types'

type Tone = 'ok' | 'err' | 'warn' | 'run' | 'idle'

const JOB_TONE: Record<JobStatus, Tone> = {
  Pending: 'idle',
  Running: 'run',
  Completed: 'ok',
  PartialSuccess: 'warn',
  Failed: 'err',
  Cancelled: 'idle',
  CancellationRequested: 'warn',
}

const JOB_LABEL: Record<JobStatus, string> = {
  Pending: 'Queued',
  Running: 'Running',
  Completed: 'Completed',
  PartialSuccess: 'Partial',
  Failed: 'Failed',
  Cancelled: 'Cancelled',
  CancellationRequested: 'Cancelling',
}

const LINE_TONE: Record<JobLineStatus, Tone> = {
  Pending: 'idle',
  Success: 'ok',
  Error: 'err',
  Skipped: 'warn',
}

export function StatusPill({ tone, label, dot }: { tone: Tone; label: string; dot?: boolean }) {
  return (
    <span className={`st st-${tone}`}>
      {dot ? <i className="st-dot" /> : null}
      {label}
    </span>
  )
}

export function JobStatusPill({ status, note }: { status: JobStatus; note?: string }) {
  const label = JOB_LABEL[status] ?? status
  return <StatusPill dot tone={JOB_TONE[status] ?? 'idle'} label={note ? `${label} · ${note}` : label} />
}

export function LineStatusPill({ status }: { status: JobLineStatus }) {
  return <StatusPill tone={LINE_TONE[status] ?? 'idle'} label={status} />
}
